import React, { useState, useEffect } from "react";
import { Table } from "reactstrap";
import WorkoutApi from "../Api";
import SetCard from "./SetCard";

const SetTable = ({ e_id }) => {
  const [sets, setSets] = useState(null);
  useEffect(() => {
    WorkoutApi.getSets(e_id).then((res) => {
      setSets(res);
    });
  }, []);
  return (
    <Table dark>
      <thead>
        <tr>
          <th>Type of Measurement</th>
          <th>Reps</th>
          <th>Weight</th>
        </tr>
      </thead>
      <tbody>
        {sets
          ? sets.map((s) => (
              <SetCard
                key={e_id}
                s_id={s.id}
                e_id={e_id}
                type_of_measurement={s.type_of_measurement}
                set_reps={s.set_reps}
                set_weight={s.set_weight}
              />
            ))
          : "loading"}
      </tbody>
    </Table>
  );
};

export default SetTable;
